// ============================================================================
// ASSIGNABLE USERS - Lista de usuarios asignables del tenant (con cache)
// ============================================================================
// Alimenta el selector "Persona asignada". Endpoint `assignable_users`
// (usuarios activos del tenant, incluido uno mismo). Cache a nivel de módulo:
// todas las instancias del picker comparten una sola petición.
// ============================================================================

import { useEffect, useState } from 'react';
import apiClient from './apiClient';
import { useAuth } from '../auth/AuthContext';

let cache = null;
let inflight = null;

export async function fetchAssignableUsers(token, force = false) {
  if (cache && !force) return cache;
  if (inflight) return inflight;

  inflight = apiClient.get('assignable_users', null, { token })
    .then((j) => {
      cache = j.status === 'success' && Array.isArray(j.data) ? j.data : [];
      inflight = null;
      return cache;
    })
    .catch(() => {
      inflight = null;
      return cache || [];
    });

  return inflight;
}

// Invalidar la cache (p.ej. tras crear un usuario o cambiar un avatar).
export function clearAssignableUsersCache() {
  cache = null;
}

// Hook: devuelve la lista de asignables (cacheada).
export function useAssignableUsers() {
  const { token } = useAuth();
  const [users, setUsers] = useState(cache || []);

  useEffect(() => {
    let alive = true;
    if (token) {
      fetchAssignableUsers(token).then((u) => {
        if (alive) setUsers(u);
      });
    }
    return () => {
      alive = false;
    };
  }, [token]);

  return users;
}
